import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "kn-page" }
const _hoisted_2 = { class: "kn-page-content p-grid p-m-0" }
const _hoisted_3 = { class: "p-col-4 p-sm-4 p-md-3 p-p-0 p-d-flex p-flex-column" }
const _hoisted_4 = { class: "p-col-8 p-sm-8 p-md-9 p-p-0 p-m-0 kn-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_ResourceManagementMetadataDialog = _resolveComponent("ResourceManagementMetadataDialog")
  const _component_ResourceManagementCreateFolderDialog = _resolveComponent("ResourceManagementCreateFolderDialog")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Tree = _resolveComponent("Tree")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_ResourceManagementDetail = _resolveComponent("ResourceManagementDetail")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.resourceManagement.title')), 1)
          ]),
          end: _withCtx(() => [
            _createVNode(_component_Button, {
              icon: "fas fa-sync-alt",
              class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadPage(_ctx.showHint, _ctx.formVisible)))
            }),
            _createVNode(_component_Button, {
              icon: "fas fa-folder-plus",
              class: "p-button-text p-button-sm p-button-rounded p-button-plain p-p-0",
              onClick: _ctx.openCreateFolderDialog
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressBar, {
              key: 0,
              mode: "indeterminate",
              class: "kn-progress-bar",
              "data-test": "progress-bar"
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ResourceManagementMetadataDialog, {
          visibility: _ctx.displayMetadataDialog,
          "onUpdate:visibility": _cache[2] || (_cache[2] = ($event: any) => (_ctx.displayMetadataDialog = $event)),
          id: _ctx.metadataKey,
          "onUpdate:id": _cache[3] || (_cache[3] = ($event: any) => (_ctx.metadataKey = $event))
        }, null, 8, ["visibility", "id"]),
        _createVNode(_component_ResourceManagementCreateFolderDialog, {
          visibility: _ctx.folderCreation,
          "onUpdate:visibility": _cache[4] || (_cache[4] = ($event: any) => (_ctx.folderCreation = $event)),
          onCreateFolder: _ctx.createFolder,
          path: _ctx.selectedFolder ? _ctx.selectedFolder.relativePath : ''
        }, null, 8, ["visibility", "onCreateFolder", "path"]),
        _createVNode(_component_Tree, {
          id: "folders-tree",
          value: _ctx.nodes,
          selectionMode: "single",
          expandedKeys: _ctx.expandedKeys,
          filter: true,
          filterMode: "lenient",
          "data-test": "functionality-tree",
          class: "kn-tree kn-flex p-flex-column foldersTree",
          onNodeSelect: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showForm($event))),
          selectionKeys: _ctx.selectedKeys,
          "onUpdate:selectionKeys": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedKeys = $event))
        }, {
          default: _withCtx((slotProps) => [
            _createVNode("div", {
              class: "p-d-flex p-flex-row p-ai-center p-jc-between",
              onMouseover: ($event: any) => (_ctx.buttonsVisible[slotProps.node.key] = true),
              onMouseleave: ($event: any) => (_ctx.buttonsVisible[slotProps.node.key] = false),
              "data-test": 'tree-item-' + slotProps.node.key
            }, [
              (!slotProps.node.edit)
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    class: "kn-truncated",
                    onDblclick: ($event: any) => (_ctx.toggleInput(slotProps.node))
                  }, _toDisplayString(slotProps.node.label), 41, ["onDblclick"]))
                : _createCommentVNode("", true),
              (slotProps.node.edit)
                ? (_openBlock(), _createBlock(_component_InputText, {
                    key: 1,
                    class: "kn-material-input fileNameInputText",
                    type: "text",
                    modelValue: slotProps.node.label,
                    "onUpdate:modelValue": ($event: any) => (slotProps.node.label = $event),
                    maxlength: "50",
                    onBlur: ($event: any) => (_ctx.toggleInput(slotProps.node)),
                    onKeyup: _withKeys(($event: any) => (_ctx.toggleInput(slotProps.node)), ["enter"])
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur", "onKeyup"]))
                : _createCommentVNode("", true),
              _createVNode("div", null, [
                (slotProps.node.modelFolder)
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      icon: "fas fa-table",
                      class: _ctx.getButtonClass(slotProps.node),
                      onClick: ($event: any) => (_ctx.openMetadataDialog(slotProps.node)),
                      "data-test": 'move-up-button-' + slotProps.node.key
                    }, null, 8, ["class", "onClick", "data-test"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('managers.resourceManagement.openMetadata'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_Button, {
                  icon: "fa fa-download ",
                  class: _ctx.getButtonClass(slotProps.node),
                  onClick: ($event: any) => (_ctx.downloadDirect(slotProps.node)),
                  "data-test": 'move-down-button-' + slotProps.node.key
                }, null, 8, ["class", "onClick", "data-test"]), [
                  [
                    _directive_tooltip,
                    _ctx.$t('common.download'),
                    void 0,
                    { top: true }
                  ]
                ]),
                (slotProps.node.level > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      icon: "far fa-trash-alt",
                      class: _ctx.getButtonClass(slotProps.node),
                      onClick: ($event: any) => (_ctx.showDeleteDialog(slotProps.node)),
                      "data-test": 'delete-button-' + slotProps.node.key
                    }, null, 8, ["class", "onClick", "data-test"])), [
                      [
                        _directive_tooltip,
                        _ctx.$t('common.delete'),
                        void 0,
                        { top: true }
                      ]
                    ])
                  : _createCommentVNode("", true)
              ])
            ], 40, ["onMouseover", "onMouseleave", "data-test"])
          ]),
          _: 1
        }, 8, ["value", "expandedKeys", "selectionKeys"])
      ]),
      _createVNode("div", _hoisted_4, [
        (_ctx.showHint)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.resourceManagement.title',
              hint: 'managers.resourceManagement.hint'
            }, null, 8, ["title", "hint"]))
          : _createCommentVNode("", true),
        (_ctx.formVisible)
          ? (_openBlock(), _createBlock(_component_ResourceManagementDetail, {
              key: 1,
              folder: _ctx.selectedFolder,
              parentKey: _ctx.folderParentKey,
              onTouched: _cache[7] || (_cache[7] = ($event: any) => (_ctx.touched = true)),
              onClose: _ctx.onClose,
              onInserted: _cache[8] || (_cache[8] = ($event: any) => (_ctx.loadPage($event))),
              onFolderCreated: _ctx.loadPage,
              onClosed: _cache[9] || (_cache[9] = ($event: any) => (_ctx.switchToHint())),
              onFileUploaded: _cache[10] || (_cache[10] = ($event: any) => (_ctx.loadPage(false, true)))
            }, null, 8, ["folder", "parentKey", "onClose", "onFolderCreated"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}